<template>
  <Layout>
    <!-- <div slot="toolbar">
      <b-button variant="outline-primary" v-b-modal.조직도 class="me-3 btn-line-toolbar org-chart">
        <b-icon icon="diagram3" /> {{ $t('조직도') }}
      </b-button>
    </div> -->
    <TableView :keep-page="keepPage" :filters="filter" :actions="['수정', '잠금', '잠금해제', '퇴사', '퇴사해제', '오류횟수 초기화', '비밀번호 초기화', '영구삭제']"
      slot="content" @action="action" @nextList="getList()" :action-filter="(item, action) => !(
        (action == '수정' && item.statusCd == 'D')
        || (action == '잠금' && item.statusCd == 'L')
        || (action == '퇴사' && item.statusCd == 'Q')
        || (action == '잠금해제' && (item.statusCd != 'L' || item.statusCd == 'Q'))
        || (action == '퇴사해제' && (item.statusCd != 'Q' || item.statusCd == 'L'))
      )" :columns="columns" :data="sel" :list="list" :server-total="total" minWidth="1400px">
      <div class="d-flex align-items-center position-relative me-3">
        <b-icon icon="search" />
        <input @change="listParams.searchKeyword = $event.target.value" class="form-control form-control-solid w-250px ps-11"
          :placeholder="$t('사용자명, 아이디, 이메일')" :title="$t('사용자명, 아이디, 이메일')">
      </div>
      <b-button variant="light-primary" v-b-modal.상세 class="me-3">
        <b-icon icon="filter" /> {{ $t('상세') }}
      </b-button>
      <b-dropdown variant="primary" size="md" class="table-action">
        <template #button-content>{{ $t('멤버 추가') }}</template>
        <b-dropdown-item @click.stop="$bvModal.show('추가');">{{ $t('신규 생성') }}</b-dropdown-item>
        <b-dropdown-item @click.stop="searchKeyword2 = ''; getManagerList();">{{ $t('기존 사용자 선택') }}</b-dropdown-item>
      </b-dropdown>
    </TableView>
    <b-modal lazy modal-class="compact text-center" centered hide-footer id="stamp" size="sm">
      <img style="max-width:100%" :src="showStamp">
    </b-modal>
    <b-modal modal-class="member" :ok-title="$t('저장')"
      @ok="action({ action: 'assignStamp', form: { stampAssignList, userId: sel.userId } })" :cancel-title="$t('취소')"
      :title="$t('회사도장 배정')" lazy id="assignStamp" centered>
      <div :key="i" v-for="({ stampTypeNm, stampNm, stampType }, i) in stampAssignList">
        <b-form-checkbox switch v-model="stampAssignList[i].assign">
          <small v-text="`${stampType != '0' ? `[${stampTypeNm}]` : ''}${stampNm}`" />
        </b-form-checkbox>
      </div>
    </b-modal>
    <b-modal @ok="action({ action: 'assignMemberProd', form: { memberProdAssignList, userId: sel.userId } })"
      modal-class="member" :ok-title="$t('저장')" :cancel-title="$t('취소')" :title="$t('멤버 Product/수행업무 배정')" lazy
      id="assignMemberProd" centered>
      <div :key="i" v-for="({ prodNm, memberTaskAssignList }, i) in memberProdAssignList">
        <b-form-checkbox @change="e => { if (!e) memberTaskAssignList.map(t => t.assign = false) }" switch
          v-model="memberProdAssignList[i].assign"><small v-text="prodNm" /></b-form-checkbox>
        <span class="ms-5">(
          <b-form-checkbox :disabled="!memberProdAssignList[i].assign" style="margin: 0 5px" :key="j"
            v-for="({ taskNm }, j) in memberTaskAssignList" v-model="memberTaskAssignList[j].assign"><small
              v-text="taskNm" /></b-form-checkbox>
          )</span>
      </div>
    </b-modal>
    
    <!-- 멤버 추가(신규생성) Modal -->
    <ModalForm @action="addAction" id="추가" ref="addMember" :title="$t('신규멤버 추가')" :data="sel" :spec="columns" @show="modalAddMember()" no-close-on-ok>
      <b-form-group :label="$t('아이디')" label-class="required" label-align="end" label-cols="5">
        <b-input-group>
          <b-form-input v-model="userIdInput" maxlength="30" />
        </b-input-group>
      </b-form-group>
      <b-form-group :label="$t('비밀번호')" label-align="end" label-cols="5" class="me-4">
        <b-form-input style="color:green" readonly="readonly" :value="'※ ' + $t('자동생성')" />
      </b-form-group>
    </ModalForm>

    <ModalForm @action="editAction" id="수정" ref="editMember" :title="$t('사용자 수정')" :data="sel" :spec="columns" @show="modalEditMember()" no-close-on-ok >
      <b-form-group :label="$t('아이디')" label-class="required" label-align="end" label-cols="5">
        <b-input-group>
          <b-form-input v-model="userIdInputEdit" maxlength="30" readonly/>
        </b-input-group>
      </b-form-group>
    </ModalForm>

    <!-- <ModalForm id="조직도" :title="$t('조직도')" /> -->
    <ModalForm id="view" :title="$t('사용자')" :data="sel" :spec="columns" />    

    <!-- 기존멤버 추가 모달 -->
    <ModalForm id="기존추가" size="lg" :title="$t('사용자 추가')" centered>
      <TableView style="margin:-20px" @action="selectAdmAction" :actions="['선택']" :columns="memberSelColumns"
        :list="managerList" :server-total="total2" minWidth="600px">
        <div class="d-flex align-items-center position-relative me-3">
          <b-icon icon="search" />
          <input :value="searchKeyword2" @keyup.enter.stop
            @change="searchKeyword2 = $event.target.value; getManagerList()"
            class="form-control form-control-solid w-250px ps-11" 
            :placeholder="$t('사용자명, 아이디, 이메일')" :title="$t('사용자명, 아이디, 이메일')">
        </div>
      </TableView>
    </ModalForm>
    <ModalForm id="상세" @cancel="detailSearch({})" modal-class="compact" title="$t('발효일')" ok-title="검색" cancel-title="초기화"
      :data="detail" close-on-backdrop ref="detailSearch" @action="detailSearch" :spec="[
        { label: '발효일', form: 1, type: 'date-between', key: 'effectDt' },
        { label: '로그인 실패 횟수 초과', form: 2, key: 'pwdErrOver', slot: 'detailSlot' }]">
      <template slot="detailSlot">
        <b-form-group label-cols='5'>
          <div class="form-check form-switch form-check-custom form-check-solid">
            <b-form-checkbox switch v-model="detail.pwdErrOver" />
          </div>
        </b-form-group>
      </template>
    </ModalForm>
  </Layout>
</template>

<script>
import Layout from "@/components/layout/Layout.vue";
import TableView from "@/components/TableView.vue";
import ModalForm from "@/components/ModalForm.vue";
const required = true;

export default {
  components: { Layout, TableView, ModalForm },
  data: () => ({
    keepPage: false, sel: {}, list: [], managerList: [], total: 0,
    total2: 0, searchKeyword2: '',
    showStamp: null, stampAssignList: [], memberProdAssignList: [],
    userIdInput: '', userIdInputEdit: '', member: {},
    columns: [
      { form: 1, label: '상태', key: 'statusNm', hide: ['추가', '수정'], style: { textAlign: 'center', minWidth: '40px' }, renderer: item => `<b class="badge badge-light-${item.statusClass}">${item.statusNm}</b>` },
      { form: 2, label: '사용자', hide: ['view', '추가', '수정'], style: { textAlign: 'center', minWidth: '80px' }, renderer: item => `${item.userNm} (${item.userIdText})` },
      { form: 3, label: '아이디', key: 'userIdText', hide: ['td', '추가', '수정'], readonly: ['수정'], required, style: { minWidth: '50px' }, },
      { form: 4, label: '이메일', key: 'email', readonly: ['수정'], type: 'email', required, style: { textAlign: 'center', minWidth: '70px' }, },
      { form: 5, label: '사용자명', key: 'userNm', hide: ['td'], required, style: { minWidth: '60px' }, },
      { form: 6, label: '사용자영문명', key: 'userNmEn', hide: ['td'], style: { textAlign: 'center', minWidth: '60px' } },
      { form: 7, label: '연락처', key: 'phone', hide: ['td'], type: 'tel', style: { textAlign: 'center', minWidth: '60px' } },
      { form: 8, label: '권한', key: 'roleNms', hide: ['추가', '수정'], style: { textAlign: 'center', minWidth: '60px' } },
      { form: 9, label: '그룹', key: 'grpNm', hide: ['추가', '수정'], readonly: ['수정'], style: { textAlign: 'center', minWidth: '60px' } },
      { form: 10, label: '발효일', key: 'effectDt', hide: ['td'], type: 'date', style: { textAlign: 'center', minWidth: '60px' }, sendMaper: v => v.replace(/-/g, ''), width: 100 },
      { form: 11, label: '로그인\n실패 횟수', key: 'pwdErrCnt', hide: ['추가', '수정'], style: { textAlign: 'center', minWidth: '40px' } },
      { form: 12, label: 'Product/수행업무', hide: ['view', '추가', '수정'], style: { textAlign: 'center', minWidth: '140px', maxWidth: '200px' }, renderer: (r) => {
          return (`
            ${r.memberProdList.map(p => `<span class="badge badge-secondary normal" data-u="viewProdTask">${p.prodTaskNm}</span>`).join('')}
            <a class="btn btn-icon btn-xs btn-light-primary" data-u="memberProdList"><i class="bi bi-plus" data-u="memberProdList"></i></a>
          `);
        }
      },
      { form: 13, label: '도장/서명', hide: ['view', '추가', '수정'], style: { textAlign: 'center', minWidth: '100px', maxWidth: '200px' }, renderer: (r) => {
          return (`
            ${r.memberStampList.map(s => `<a class="badge badge-secondary normal" data-u="viewMemberStamp" data-url="${s.stampFileUrl}">[${s.stampTypeNm}]${s.stampNm}</a>`).join('')}
          `);
        }
      },
      { form: 14, label: '회사도장', hide: ['view', '추가', '수정'], style: { textAlign: 'center', minWidth: '100px', maxWidth: '200px' }, renderer: (r) => {
          return (`
            ${r.stampAssignList.map(p => `<a class="badge badge-secondary normal" data-u="viewCustStamp" data-url="${p.stampFileUrl}">${p.stampType != '0' ? `[${p.stampTypeNm}]` : ''}${p.stampNm}</a>`).join('')}
            <a class="btn btn-icon btn-xs btn-light-primary" data-u="stampAssignList"><i class="bi bi-plus" data-u="stampAssignList"></i></a>
          `);
        }
      },
      { form: 15, label: '인증서', hide: ['view', '추가', '수정'], style: { textAlign: 'left', minWidth: '140px', maxWidth: '200px' }, renderer: (r, s) => {
          if(r.memberCertiList && r.memberCertiList.length > 0) {            
            return `
              <div class="d-flex flex-column justify-content-center">
                ${r.memberCertiList.map(certi => {
                  const label = certi.certiStatusCd == 'ACTIVE' ? s.$t('비활성') : s.$t('활성');
                  const id = `certi_${certi.memberId}_${certi.certiSeq}`;
                  setTimeout(() => {
                    const certiEl = document.getElementById(id);
                    certiEl.addEventListener('click', function(event) {
                      event.preventDefault();
                    });
                    certiEl.checked = (certi.certiStatusCd == 'ACTIVE');
                  }, 100);

                  return `
                    <div class="d-flex align-items-center mb-3">
                      <div class="custom-control custom-switch">
                        <input type="radio" class="custom-control-input" id="${id}" data-u="activeCerti" data-seq="${certi.certiSeq}" data-status="${certi.certiStatusCd}" data-label="${label}" />
                        <label class="custom-control-label" for="${id}"></label>
                      </div>
                      <div class="text-${certi.certiStatusTextClass} normal ps-12">[${certi.certiTypeNm}] ${certi.idn}</div>
                    </div>
                  `;
                }).join('')
                }
              </div>
            `;
          }
        }
      },
    ],
    memberSelColumns: [   // 멤버추가 > 멤버 선택
      { key: 'userNm', label: '사용자', renderer: item => `${item.userNm} (${item.userIdText})`, style: { textAlign: 'center' } },
      { key: 'email', label: '이메일', style: { textAlign: 'center' } },
    ],
    listParams: { searchKeyword: '', statusCd: null, memberType: null, effectDtFrom: '', effectDtTo: '', pwdErrOver: 'N' },
    detail: { effectDt: ['', ''], pwdErrOver: false },
    filter: [{ key: 'statusCd', label: '상태', cd: 'MEMBER_STATUS' }],
    // filter: [{key:'statusCd', label:'상태', cd: 'MEMBER_STATUS'},{key:'memberType', label:'유형', cd: 'MEMBER_TYPE'}],
    // filter: { statusNm: [], grpNm: [], roleNms: [], },
  }),
  created() { this.getList() },
  mounted() { },
  beforeDestroy() { },
  computed: {},
  watch: {
    listParams: { deep: true, handler() { this.getList(true); } },
  },
  methods: {
    detailSearch({ form }) {
      setTimeout(() => document.activeElement.blur(), 500);
      if (form) this.detail.effectDt = form.effectDt;
      const check = this.detail.effectDt.join('');
      if (!form && !check) return;
      else if (!form) this.detail.effectDt = ['', ''];
      else if (form && form.effectDt[0] && form.effectDt[1] && form.effectDt[0] > form.effectDt[1]) return this.$alert(this.$t('시작범위가 종료범위보다 큽니다.'));
      this.listParams.effectDtFrom = this.detail.effectDt[0];
      this.listParams.effectDtTo = this.detail.effectDt[1];
      this.listParams.pwdErrOver = this.detail.pwdErrOver === true ? 'Y' : 'N';
    },
    async action({ action, item, form, event }) {
      if (item) this.sel = item;
      if (['view', '수정'].includes(action)) {
        if (event) {
          const { target: { dataset: { u, seq, label, status, url } } } = event;

          // 회사도장 배정
          if (u == 'stampAssignList') {
            this.stampAssignList = (await this.$api('main/member/selectStampAssignFormList', { userId: item.userId })).list;
            return this.$bvModal.show('assignStamp');
          }

          // 개인도장, 회사도장 조회
          if (u == 'viewMemberStamp' || u == 'viewCustStamp') {
            this.showStamp = this.$url(url);
            this.$bvModal.show('stamp') ;
            return;
          }

          // Product, 수행업무 배정
          if (u == 'memberProdList' || u == 'viewProdTask') {
            this.memberProdAssignList = (await this.$api('main/member/selectMemberProdFormList', { userId: item.userId })).list;
            return this.$bvModal.show('assignMemberProd');
          }

          // 인증서
          if (u == 'activeCerti') {
            let statusReason;
            window.getStatusReason = v => statusReason = v;
            let contents = `
              <div>
                <div class="mb-3">${this.$t('해당 항목을 $ 처리하시겠습니까?', [label])}</div>
                <textarea style="width:100%" onchange="getStatusReason(this.value)" placeholder="${this.$t('비고')}"></textarea>
              </div>
            `;

            if (await this.$alert(contents, { okTitle: label, title: label, confirm: true })) {
              let certiStatusCd = status == 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
              const res = await this.$api(`main/member/activeCerti`, {userId: this.sel.userId, certiSeq: seq, certiStatusCd: certiStatusCd, certiStatusReason: statusReason});
              if (!res.success) {
                return this.$alert(res.msg);
              } else {
                await this.$alert(res.msg);
                if (res.success) {
                  this.refreshMember(res.data);
                  return;
                }
              }              
            }

            return;
          }
        }

        const unmaskKey = await this.$unmask(action == 'view' ? 'MEMBER_INFO' : 'MEMBER_UPD');
        var selMember = (await this.$api('main/member/selectMember', { masking: false, unmaskKey, userId: this.sel.userId })).data;
        for (const key in selMember) { 
          this.sel[key] = selMember[key];
        }
        this.userIdInputEdit = selMember.userIdText;

        return this.$bvModal.show(action);
      } else if (['잠금', '잠금해제', '퇴사', '퇴사해제', '오류횟수 초기화', '비밀번호 초기화'].includes(action)) {
        if (!(await this.$alert(this.$t('[$] 사용자를 $ 하시겠습니까?', [item.userNm, action]), { confirm: true, title: action }))) return;
        const res = await this.$api(`main/member/${({ 잠금: 'lockMember', 잠금해제: 'unlockMember', 퇴사: 'quitMember', 퇴사해제: 'unquitMember', '오류횟수 초기화': 'initPwdErrCnt', '비밀번호 초기화': 'initUserPwd' })[action]}`, { userId: item.userId });
        await this.$alert(res.msg);
        if (res.success) {
          this.refreshMember(res.data);
          return;
        }
      } else if (['영구삭제'].includes(action)) {
        const confirmBody = `
          <div>
            <div>${this.$t('[$] 사용자를 $ 하시겠습니까?', [this.sel.userNm, action])}</div>
            <div class="mt-5">
              <div class="form-check form-check-sm form-check-custom form-check-solid">
                <input type="checkbox" class="form-check-input me-4" id="personalInfoDelConfirm" />
                <label for="personalInfoDelConfirm" class="text-danger">${this.$t('계정 삭제 시, 모든 데이터가 영구 삭제되는 것에 동의합니다.')}</label>
              </div>
            </div>
          </div>
        `;

        form = { userId: this.sel.userId, memberId: this.sel.memberId };
        let confirmClose = false;
        let time = 0;
        while(!confirmClose && time++ < 5) {
          if (await this.$alert(confirmBody, { confirm: true, title: action, size: 'w-325' })) {
            form.personalInfoDelConfirm = document.getElementById('personalInfoDelConfirm').checked;
            const res = await this.$api(`main/member/deleteMember`, form);
            await this.$alert(res.msg);
            if(res.success) {
              confirmClose = true;
              this.getList(true);
            }            
          } else {
            confirmClose = true;
          }
        }

        return;
      } else if (['assignMemberProd', 'assignStamp'].includes(action)) {
        form.userId = this.sel.userId;
        form.memberId = this.sel.memberId;

        const res = await this.$api(`main/member/${({ assignStamp: 'assignStamp', assignMemberProd: 'assignMemberProd' })[action]}`, form);
        await this.$alert(res.msg);
        if (res.success) {
          this.refreshMember(res.data);
          return;
        }
      }
    },
    // 기존멤버 선택 리스트
    async getManagerList(firstIndex = 1) {
      const res = await this.$api('main/member/selectMemberAssignUserList', { firstIndex, searchKeyword: this.searchKeyword2 });
      this.total2 = res.parameter.total;
      this.managerList = firstIndex == 1 ? res.list : this.managerList.concat(res.list);
      this.$bvModal.show('기존추가');
    },
    // 기존멤버 선택 Action
    async selectAdmAction({ action, item }) {
      const { id: custId } = this.$route.query;
      this.seluser = item;
      const userId = item.userId;
      if (['선택'].includes(action)) {
        const res = await this.$api('main/member/assignMember', { custId, userId });  //조직 멤버 입력
        this.itemManager = this.seluser.userNm;
        await this.$alert("적용되었습니다.");
        if (res.success) this.getList(true); this.getManagerList();
        this.$bvModal.hide('userSelect');
      }
    },
    // 멤버 신규추가 Show
    async modalAddMember() {
      this.userIdInput = '';
      const formattedDate = new Date().toLocaleString('sv-SE', { hour12: false }).replace(',', '').slice(0, 10);
      this.$refs.addMember._data.form.effectDt = formattedDate;
    },
    async modalEditMember() {
      const { form, spec } = this.$refs.editMember;
      const cutEffectDt = this.sel.effectDt;
      for (const key in this.sel) if (spec.find(s => s.key == key)) {
        form[key] = this.sel[key];
        form.effectDt = cutEffectDt.slice(0,4) + "-" + cutEffectDt.slice(4,6) + "-" + cutEffectDt.slice(6,8);
      }
    },
    async addAction({ form }) {
      form.userId = this.userIdInput;
      const res = await this.$api(`main/member/insertMember`, form);
      await this.$alert(res.msg);
      if (res.success) this.$bvModal.hide("추가"); this.getList(true); 
    },
    async editAction({ form, action }) {
      if (!(await this.$alert(this.$t('[$] 사용자를 $ 하시겠습니까?', [this.sel.userNm, action]), { confirm: true, title: action }))) return;
      form.userId = this.sel.userId;
      const res = await this.$api(`main/member/updateMember`, form);
      await this.$alert(res.msg);
      if (res.success) { this.$bvModal.hide("수정"); this.getList(true); }
    }, 
    async newMngClick() {
      this.userIdInput = '';
    },
    async getList(reset) {
      if (reset === true) this.list = [];
      const { list, parameter: { total } } = await this.$api('main/member/selectMemberList', { ...this.listParams, firstIndex: this.list.length + 1 });
      this.total = total;
      this.list.push(...list);
    },
    async refreshMember(member) {
      this.keepPage = true;
      this.$set(this.list, this.list.findIndex(item => item.userId === member.userId), member);
      this.$nextTick(()=> { this.keepPage = false; });
    },
  },
}
</script>
